import './assets/LabeledTextInput.component.css';const s = "_label_sfkp4_2", e = "_secondary_sfkp4_2", a = {
  label: s,
  secondary: e
};
export {
  a as s
};
